import { render, staticRenderFns } from "./ChangeForgottenPassword.vue?vue&type=template&id=f24807b8&scoped=true&"
import script from "./ChangeForgottenPassword.vue?vue&type=script&lang=ts&"
export * from "./ChangeForgottenPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeForgottenPassword.vue?vue&type=style&index=0&id=f24807b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24807b8",
  null
  
)

export default component.exports